if (process.env.NODE_ENV === 'development') {
  module.exports = {
    AMPLITUDE_KEY: '88733ce0d6335ffc37790dd26aac1c2d',
  }
} else {
  module.exports = {
    AMPLITUDE_KEY: 'bda244d9b34abffb35fb9767aeb289b6',
  }
}
